const getTotalRefundedValue = (data) => {
    if (data?.order?.payments?.length) {
        return data.order.payments
            .filter((i) => i.status === 'succeeded' || i.status === 'refunded')
            .reduce((acc, obj) => {
                return acc + obj.totalRefunded;
            }, 0);
    }
};

export default getTotalRefundedValue;
